/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ManagerResponse } from './';
import {
    ManagerResponseFromJSON,
    ManagerResponseFromJSONTyped,
    ManagerResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchManagerResponse
 */
export interface SearchManagerResponse {
    /**
     * 
     * @type {Array<ManagerResponse>}
     * @memberof SearchManagerResponse
     */
    managers?: Array<ManagerResponse>;
}

/**
 * Check if a given object implements the SearchManagerResponse interface.
 */
export function instanceOfSearchManagerResponse(value: object): value is SearchManagerResponse {
    return true;
}

export function SearchManagerResponseFromJSON(json: any): SearchManagerResponse {
    return SearchManagerResponseFromJSONTyped(json, false);
}

export function SearchManagerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchManagerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'managers': json['managers'] == null ? undefined : ((json['managers'] as Array<any>).map(ManagerResponseFromJSON)),
    };
}

export function SearchManagerResponseToJSON(value?: SearchManagerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'managers': value['managers'] == null ? undefined : ((value['managers'] as Array<any>).map((v) => ManagerResponseToJSON(v))),
    };
}

